module.exports = __webpack_public_path__ + "assets/img/1.ba73ab7b.png";